import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const AirQualityCard = ({ title, unit, value, percent, last, trend, quality_fn }) => {
  const isTrendUp = trend > 0;
  const quality = quality_fn(value);
  const display = quality.level;
  const color = quality.color;
  return (
    <div style={{ border: '1px solid #e5e7eb', padding: '1rem', paddingTop: '0.5rem', borderRadius: '0.5rem', boxShadow: "0 4px 10px rgba(0,0,0,0.06)", width: '250px' }}>
      <h2 style={{ marginBottom: '0.5rem', marginTop: '0.5rem' }}>{title}</h2>

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
        <div style={{ width: 60, height: 60 }}>
          <CircularProgressbar
            value={percent ? percent : 100}
            text={display ? display : `${percent.toFixed(0)}%`}
            styles={buildStyles({
              pathColor: color,
              textColor: color,
              textSize: '24px'
            })}
          />
        </div>
        <div style={{ marginLeft: '1rem' }}>
          <div style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>
            {value} {unit}
          </div>
          {trend != 0 && <div style={{ color: isTrendUp ? 'red' : '#3b82f6', fontWeight: 600 }}>
            ({trend > 0 ? '+' : ''}{trend}%){isTrendUp ? '↑' : '↓'}
          </div>}
        </div>
      </div>

      <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>
        Last Week: {last} {unit}
      </div>
    </div>
  );
};

export default AirQualityCard;
